<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-2 shape-red shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2 class="display-2 text-white">Online Reports
                                    <span>Our online reports reflect state-of-the-art technology.</span>
                                </h2>
                                <p class="lead  text-white">Its comprehensive and friendly interface can present, manipulate, and analyze data in both text and graphical representations. It provides an easy, quick, responsive, and complete report system.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section class="section section-lg bg-secondary section-skew">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-12">
                        <h2 class="display-2">Online Report System </h2>
                        <!-- <p class="lead text-muted">Mainline Non-Vital Computer Aided Dispatching System</p> -->
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 col-lg-12 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/3z/CarDetail.jpeg'"
                                 class="rounded img-center img-fluid shadow shadow-lg--hover">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Report page</span>
                                    <small class="h6 text-muted">Car Detail</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>

<style lang="scss" scoped>
ul.list {
    padding-left: 1.2rem!important;
}
.section-skew {
    overflow: hidden;
    // padding-top: 20px;
    margin-top: 0px;
    position: relative;
    background: transparent;
    pointer-events: none;
    overflow: visible;
    &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: -120px;
        height: 200px;
        background: #f4f5f7;
        -webkit-transform: skew(0, -8deg);
        transform: skew(0, -8deg);
    }
}
</style>
